var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.8C6.91898 2.8 2.8 6.91898 2.8 12C2.8 17.081 6.91898 21.2 12 21.2C17.081 21.2 21.2 17.081 21.2 12C21.2 6.91898 17.081 2.8 12 2.8ZM13.2529 7.00001C15.107 7.00001 16.61 8.50306 16.61 10.3572C16.61 12.2113 15.107 13.7143 13.2529 13.7143L11 13.714V15H12.5C12.9142 15 13.25 15.3358 13.25 15.75C13.25 16.1642 12.9142 16.5 12.5 16.5H11V17.15C11 17.6195 10.6194 18 10.15 18C9.68056 18 9.3 17.6195 9.3 17.15L9.299 16.5H8.5C8.08579 16.5 7.75 16.1642 7.75 15.75C7.75 15.3358 8.08579 15 8.5 15H9.299V13.714L8.60714 13.7143C8.13376 13.7143 7.75 13.3305 7.75 12.8572C7.75 12.3838 8.13376 12 8.60714 12H9.299L9.3 7.85001C9.3 7.38057 9.68056 7.00001 10.15 7.00001H13.2529ZM13.2857 8.57144H11V12H13.2857C14.2325 12 15 11.2325 15 10.2857C15 9.33895 14.2325 8.57144 13.2857 8.57144Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCircleOutline);
export default __webpack_public_path__ + "static/media/money_circle_outline.bae022c418fc41a3227c9caa1f7d7d54.svg";
export { ForwardRef as ReactComponent };